// extracted by mini-css-extract-plugin
export default {"button":"ADJyA6","link":"zDHo5K","container":"AwuIcq","mobile-container":"pJvZeH","mobileContainer":"pJvZeH"};